module.exports = "<form-modal [(form)]=\"form\">\n    <chassis-form [(form)]=\"form\"></chassis-form>\n</form-modal>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-plugin-modal/list-plugin.modal.html
// module id = ./libs/chassis-core/src/app/plugins/abstract-plugins/list/components/list-plugin-modal/list-plugin.modal.html
// module chunks = main